"use strict";

var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 11",
    width: "6",
    height: "11"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3899EC",
    fillRule: "evenodd",
    d: "M.897 10.98c.19 0 .372-.08.5-.222l4.4-4.74a.788.788 0 0 0 0-1.06L1.197.22a.67.67 0 0 0-.991 0 .794.794 0 0 0 0 1.064l4.11 4.21L.416 9.7a.795.795 0 0 0 0 1.065c.126.134.3.212.482.215z"
  }));
};